import { isDeleteBackwardAllowed, getListItems, getLists, getListType, getNestedList, getParentList, getParentListItem, isAtStartOfListItem, isAtEmptyListItem, isInList, isListItemContainingText } from "./lib/index.js";
import * as Registry from "./registry.js";
import { decreaseDepth, decreaseListItemDepth, increaseDepth, increaseListItemDepth, mergeListWithPreviousSiblingList, moveListItemsToAnotherList, moveListToListItem, setListType, splitListItem, unwrapList, wrapInList } from "./transformations/index.js";
import { ListType } from "./types.js";
function schema(editor) {
  return Registry.get(editor);
}
export const ListsEditor = {
  // ListsEditor schema availability
  isListsEnabled(editor) {
    return Registry.has(editor);
  },
  getListsSchema(editor) {
    return Registry.has(editor) ? Registry.get(editor) : undefined;
  },
  // Schema proxies
  isConvertibleToListTextNode(editor, node) {
    return schema(editor).isConvertibleToListTextNode(node);
  },
  isDefaultTextNode(editor, node) {
    return schema(editor).isDefaultTextNode(node);
  },
  isListNode(editor, node, type) {
    return schema(editor).isListNode(node, type);
  },
  isListItemNode(editor, node) {
    return schema(editor).isListItemNode(node);
  },
  isListItemTextNode(editor, node) {
    return schema(editor).isListItemTextNode(node);
  },
  createDefaultTextNode(editor, props) {
    return schema(editor).createDefaultTextNode(props);
  },
  createListNode(editor, type, props) {
    return schema(editor).createListNode(type, props);
  },
  createListItemNode(editor, props) {
    return schema(editor).createListItemNode(props);
  },
  createListItemTextNode(editor, props) {
    return schema(editor).createListItemTextNode(props);
  },
  // Checks & Getters
  isDeleteBackwardAllowed(editor, at) {
    return isDeleteBackwardAllowed(editor, schema(editor), at);
  },
  isAtStartOfListItem(editor, at) {
    return isAtStartOfListItem(editor, schema(editor), at);
  },
  isAtEmptyListItem(editor, at) {
    return isAtEmptyListItem(editor, schema(editor), at);
  },
  isAtList(editor, at) {
    return isInList(editor, schema(editor), at);
  },
  isListItemContainingText(editor, node) {
    return isListItemContainingText(editor, schema(editor), node);
  },
  getLists(editor, at) {
    return getLists(editor, schema(editor), at);
  },
  getListItems(editor, at) {
    return getListItems(editor, schema(editor), at);
  },
  getListType(editor, node) {
    return getListType(schema(editor), node);
  },
  getNestedList(editor, path) {
    return getNestedList(editor, schema(editor), path);
  },
  getParentList(editor, path) {
    return getParentList(editor, schema(editor), path);
  },
  getParentListItem(editor, path) {
    return getParentListItem(editor, schema(editor), path);
  },
  // Transformations
  increaseDepth(editor, at) {
    return increaseDepth(editor, schema(editor), at);
  },
  increaseListItemDepth(editor, listItemPath) {
    return increaseListItemDepth(editor, schema(editor), listItemPath);
  },
  decreaseDepth(editor, at) {
    return decreaseDepth(editor, schema(editor), at);
  },
  decreaseListItemDepth(editor, listItemPath) {
    return decreaseListItemDepth(editor, schema(editor), listItemPath);
  },
  mergeListWithPreviousSiblingList(editor, entry) {
    return mergeListWithPreviousSiblingList(editor, schema(editor), entry);
  },
  moveListItemsToAnotherList(editor, parameters) {
    return moveListItemsToAnotherList(editor, schema(editor), parameters);
  },
  moveListToListItem(editor, parameters) {
    return moveListToListItem(editor, schema(editor), parameters);
  },
  setListType(editor, listType, at) {
    return setListType(editor, schema(editor), listType, at);
  },
  splitListItem(editor, at) {
    return splitListItem(editor, schema(editor), at);
  },
  unwrapList(editor, at) {
    return unwrapList(editor, schema(editor), at);
  },
  wrapInList(editor) {
    let listType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ListType.UNORDERED;
    let at = arguments.length > 2 ? arguments[2] : undefined;
    return wrapInList(editor, schema(editor), listType, at);
  }
};